import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUserRoleAndSubscription } from "../hooks/useUserRoleAndSubscription";
import { isDefaultTemplatesAdmin } from "../helpers/access_control_helpers";

export const AdminRoute = () => {
  const { isSuperAdmin, email } = useUserRoleAndSubscription();
  const location = useLocation();

  const isDefaultTemplatesRoute = location.pathname.startsWith(
    "/admin/default-templates"
  );

  if (isDefaultTemplatesRoute) {
    if (!isSuperAdmin || !isDefaultTemplatesAdmin(email)) {
      return <Navigate to="/cases" replace />;
    }
  }
  // For other admin routes, just check superadmin status
  else if (!isSuperAdmin) {
    return <Navigate to="/cases" replace />;
  }

  // If all checks pass, render the admin components
  return <Outlet />;
};
